import { MeetingParticipantModel } from '@/types';

export interface MeetingParticipantWithSpeechPercentageModel extends MeetingParticipantModel {
    speechPercentage: number;
}
